import { type FeatureKey } from "@ds/modules/features/@types";
import { selectFeatureByKey, selectFeaturesIsSucceeded } from "@ds/modules/features/redux/selectors";
import { selectCurrentUserProjectId } from "@ds/modules/settings/users/redux/selectors";

import { useRootSelector } from "./redux-hooks";

export const useFeature = (featureKey: FeatureKey, projectId: number) => {
  const feature = useRootSelector(state => selectFeatureByKey(state, projectId, featureKey));
  return feature;
};

export const useCurrentProjectFeature = (featureKey: FeatureKey) => {
  const currentProjectId = useRootSelector(selectCurrentUserProjectId);
  return useFeature(featureKey, currentProjectId);
};

export const useCurrentProjectFeatureEnabled = (featureKey: FeatureKey) => {
  const currentProjectId = useRootSelector(selectCurrentUserProjectId);
  const feature = useFeature(featureKey, currentProjectId);
  const isEnabled = feature?.enabled ?? false;

  return isEnabled;
};

export const useIsCurrentProjectFeaturesLoaded = () => useRootSelector(selectFeaturesIsSucceeded);
